import styled from 'styled-components';

export const Footer = styled.div`
    width: 100vw;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    position: fixed;
    bottom: 0;
    z-index: 10001;
`;

export const FooterContent = styled.div`
    width: 100%;
    position: relative;
`;

export const LeftBoxContainer = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
`;

export const RightBoxContainer = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
`;

export const QRCodeBox = styled.div`
    width: 95px;
    height: 95px;
    background-color: ${props => (props.isEmpty ? 'none' : 'white')};
    border: ${props => (props.isEmpty ? 'none' : '2px solid white')};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const BoardTypeBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TimeValue = styled.div`
    width: 55px;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Footer/style.js